<mat-card>
  <div class="title-row">
    <mat-card-title class="small-title">{{ viewMode ? 'Song Details' : 'Edit Song' }}</mat-card-title>
    <button *ngIf="viewMode" mat-button class="close-top-btn" type="button" (click)="closeDialog()">Close</button>
  </div>
  <mat-card-content>
    <form *ngIf="!viewMode" [formGroup]="editForm" (ngSubmit)="saveChanges()">
      <!-- Song Details Form -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Composer</mat-label>
          <mat-select formControlName="composerId">
            <mat-option *ngFor="let composer of composers" [value]="composer.id">
              {{ composer.fullName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Genre</mat-label>
          <input matInput formControlName="genre">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Genre Group</mat-label>
          <input matInput formControlName="genreGroup">
        </mat-form-field>
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Voicing</mat-label>
          <input matInput formControlName="voicing">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Instruments</mat-label>
          <input matInput formControlName="instruments">
        </mat-form-field>
      </div>

      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Language</mat-label>
          <input matInput formControlName="language">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Year</mat-label>
          <input matInput type="number" formControlName="year">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Resource Folder</mat-label>
          <input matInput formControlName="resourceFolder">
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments"></textarea>
      </mat-form-field>
    </form>

  <div *ngIf="viewMode" class="view-mode">
      <p><strong>Name:</strong> {{ data.song?.name }}</p>
      <p><strong>Composer:</strong> {{ composerFullName }}</p> <!-- Display composer's full name -->
      <p><strong>Genre:</strong> {{ data.song?.genre }}</p>
      <p><strong>Genre Group:</strong> {{ data.song?.genreGroup }}</p>
      <p><strong>Voicing:</strong> {{ data.song?.voicing }}</p>
      <p><strong>Instruments:</strong> {{ data.song?.instruments }}</p>
  <p *ngIf="(data.song?.comments || '').trim().length > 0"><strong>Comments:</strong> {{ data.song?.comments }}</p>
    </div>
  </mat-card-content>

  <!-- Song Resources Subcomponent -->
  <mat-divider></mat-divider>
  <mat-card-content class="resources-section">
    <app-resource-song 
      [songId]="data.song?.id ?? 0" 
      [viewMode]="viewMode" 
      [resourceFolder]="editForm.get('resourceFolder')?.value || ''">
    </app-resource-song>
  </mat-card-content>

  <!-- Buttons at the bottom -->
  <mat-card-actions *ngIf="!viewMode">
    <div class="form-actions">
      <button mat-raised-button color="primary" type="submit" (click)="saveChanges()">Save</button>
      <button mat-raised-button color="warn" type="button" (click)="closeDialog()">Cancel</button>
    </div>
  </mat-card-actions>
</mat-card>
